export const firebaseConfig = {
    apiKey: "AIzaSyDoLoE859XbmxJCj5xbj6fBP8SLbqt5pJc",
    authDomain: "jradio-fb4af.firebaseapp.com",
    projectId: "jradio-fb4af",
    storageBucket: "jradio-fb4af.appspot.com",
    messagingSenderId: "492635119780",
    appId: "1:492635119780:web:815c9fa5412b4520d58631",
    measurementId: "G-332Z52Y4KH"
  };